(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const root = document.documentElement;

  const updateHeroHeader = () => {
    const body = document.body;
    if (!body?.classList.contains('template-index')) return;
    const firstSection = document.querySelector('#MainContent > .shopify-section:first-child');
    const transparentHeader = document.querySelector('.header-wrapper')?.dataset.luxTransparentHeader === 'true';
    body.classList.toggle(
      'lux-has-hero',
      Boolean(transparentHeader && firstSection?.classList.contains('lux-section--hero')),
    );
  };

  const updateHeaderState = () => {
    root.classList.toggle('lux-scrolled', window.scrollY > 16);
  };

  let headerFrame;
  window.addEventListener(
    'scroll',
    () => {
      if (headerFrame) return;
      headerFrame = window.requestAnimationFrame(() => {
        updateHeaderState();
        headerFrame = undefined;
      });
    },
    { passive: true },
  );
  updateHeaderState();
  updateHeroHeader();

  const setupReel = (reel) => {
    if (!reel || reel.dataset.luxReady === 'true') return;

    const track = reel.querySelector('[data-lux-reel-track]');
    const previous = reel.querySelector('[data-lux-reel-prev]');
    const next = reel.querySelector('[data-lux-reel-next]');
    if (!track || !previous || !next) return;

    reel.dataset.luxReady = 'true';

    const updateControls = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    };

    const move = (direction) => {
      const amount = Math.max(track.clientWidth * 0.78, 280) * direction;
      track.scrollBy({ left: amount, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  };

  const setupReels = (scope = document) => {
    scope.querySelectorAll('[data-lux-reel]').forEach(setupReel);
  };

  setupReels();
  document.addEventListener('shopify:section:load', (event) => {
    setupReels(event.target);
    updateHeroHeader();
  });
  document.addEventListener('shopify:section:unload', updateHeroHeader);
  document.addEventListener('shopify:section:reorder', updateHeroHeader);
})();
